import React from 'react';
import classes from './SkeletonMenu.module.scss';
import classesMenu from '../../../pages/Menu/MenuGeneral/MenuGeneral.module.scss';
import Skeleton from '../Skeleton';
import { GeneralContext } from '../../../context/generalContext';
import SkeletonMenuCard from '../SkeletonMenuCard/SkeletonMenuCard';

export default function SkeletonMenu() {
  const { windowWidth, subdomainIsActive } = React.useContext(GeneralContext);

  const sectionsItems = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const menuItems = [1, 2, 3, 4, 5, 6];
  const [textItems, setTextItems] = React.useState([1, 2, 3]);

  React.useEffect(() => {
    if (windowWidth <= 767) {
      setTextItems([1, 2, 3, 4, 5, 6]);
    }
  }, [windowWidth]);

  return (
    <>
      <div className={classesMenu.menuGeneralLeft}>
        {!subdomainIsActive && (
          <div>
            <div className={classes.menuHeader1}>
              <Skeleton borderRadius='5px' width='100%' height={20} isLight={false} />
            </div>
            <div className={classes.dropdown}>
              <Skeleton borderRadius='5px' width='100%' height={15} isLight={false} />
            </div>
            <div className={classes.menuHeader3}>
              <Skeleton borderRadius='5px' width='100%' height={20} isLight={false} />
            </div>
          </div>
        )}
        <div className={classes.menuSectionsDiv}>
          <div className={classes.menuSections}>
            {sectionsItems.map((_, index) => (
              <div className={classes.menuSectionsItem} key={index}>
                <Skeleton borderRadius='5px' width='100%' height={15} isLight={false} />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={classesMenu.menuGeneralRight}>
        <div className={classes.menuHeader2}>
          <Skeleton borderRadius='5px' width={250} height={25} isLight={false} />
        </div>
        <div className={classes.menuItems}>
          {menuItems?.length > 0 && menuItems.map((_, index) => <SkeletonMenuCard key={index} />)}
        </div>
        <div className={classesMenu.menuInformation}>
          <div className={classes.menuInformationText}>
            {textItems.map((_, index) => (
              <div className={classes.textItem} key={index}>
                <Skeleton borderRadius='5px' width='100%' height={15} isLight={false} />
              </div>
            ))}
          </div>
          <div className={classes.button}>
            <div className={classes.buttonBody}>
              <Skeleton borderRadius='0' width='100%' height={50} isLight />
            </div>
            <div className={classes.buttonText}>
              <Skeleton borderRadius='5px' width='100%' height={15} isLight={false} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
